import { PriceUtils } from '@ecp/common/src/utils/price/PriceUtils';

const SKYPASS_GOOD_PRICE_FILTER_LIST = [
  {
    key: '1',
    label: '0마일 ~ 2,000마일',
    min: 0,
    max: 2000,
  },
  {
    key: '2',
    label: '2,000마일 ~ 5,000마일',
    min: 2000,
    max: 5000,
  },
  {
    key: '3',
    label: '5,000마일 ~ 20,000마일',
    min: 5000,
    max: 20000,
  },
  {
    key: '4',
    label: '20,000마일 ~ 50,000마일',
    min: 20000,
    max: 50000,
  },
  {
    key: '5',
    label: '50,000마일 ~ 100,000마일',
    min: 50000,
    max: 100000,
  },
  {
    key: '6',
    label: '100,000마일 ~ 200,000마일',
    min: 100000,
    max: 200000,
  },
  {
    key: '7',
    label: '200,000마일 이상',
    min: 200000,
    max: '',
  },
];

/**
 * PriceFilter 에선 타사이트와 공통으로 사용하기 위해
 * 최초데이터(원화) -> 사용자에게 보여지는데이터(formattedPrice) -> 백엔드로 쏠때 데이터(원화)
 * 이므로 최초데이터 제공 시 원화로 변경
 */
function getSkypassGoodPriceFilterList(priceFormatPerKrw) {
  const priceUtils = new PriceUtils();

  return SKYPASS_GOOD_PRICE_FILTER_LIST.map((it) => {
    const min = priceUtils.toKrw(it.min, priceFormatPerKrw);
    const max = priceUtils.toKrw(it.max, priceFormatPerKrw);

    return {
      ...it,
      min,
      max,
    };
  });
}

export { SKYPASS_GOOD_PRICE_FILTER_LIST, getSkypassGoodPriceFilterList };
